import { render, staticRenderFns } from "./AbasVtal.vue?vue&type=template&id=671d0b27&scoped=true&lang=pug&"
import script from "./AbasVtal.vue?vue&type=script&lang=js&"
export * from "./AbasVtal.vue?vue&type=script&lang=js&"
import style0 from "./AbasVtal.vue?vue&type=style&index=0&id=671d0b27&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d0b27",
  null
  
)

export default component.exports